var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGefionFacility14({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8281 9.41406H47.0508V14.1016H18.8281V9.41406Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0V80H80V0H0ZM30.5859 75.3125H14.1016V23.5156H30.5859V75.3125ZM51.7773 75.3125H35.2734V23.5156H51.7773V75.3125ZM75.3125 75.3125H56.4648V18.8281H9.41406V75.3125H4.6875V4.6875H75.3125V75.3125Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4083 54.1873L69.0938 50.8728L66.0439 53.9225L62.9942 50.8728L59.6797 54.1873L66.0439 60.5516L72.4083 54.1873Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0439 44.9057L69.0938 47.9554L72.4083 44.6408L66.0439 38.2766L59.6797 44.6408L62.9942 47.9554L66.0439 44.9057Z",
    fill: "#C49A36"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGefionFacility14);
export default __webpack_public_path__ + "static/media/gefion-facility-14.7cb59dad26c794f35c681550775a7dbd.svg";
export { ForwardRef as ReactComponent };